import store from "@/store";
import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToBooking = async () => {
  if (store.getters["common/device"] == "BROWSER") {
    router.push({
      name: "DbsMyBooking",
    });
  } else {
    nativeHandlerService.ncDbsOpenWebview(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}dbs/my-booking`
    );
  }
};
